import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ISent_Messages {
  id: number;
  mailing: string;
  user_contact: string;
  message_template: string;
  message_type: string;
  sender_name: string;
  message_status: string;
  provider: string;
  id_Value: string;
  date_added_to_tasks: null | string;
  date_sent: null | string;
}

interface ISent_MessagesData {
  list?: Array<ISent_Messages>;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
  totalCount?: number;
  message?: { text: string; type: string };
}

const initialState: ISent_MessagesData = {
  pageNo: 1,
  pageSize: 20,
  searchKey: "",
  list: [],
  totalCount: 0,
  message: { text: "", type: "" },
};

const sent_messagesSlice = createSlice({
  name: "sent_messages",
  initialState,
  reducers: {
    setSent_MessagesList: (
      state,
      _action: PayloadAction<ISent_MessagesData>
    ) => {
      state.list = _action.payload.list;
      state.pageNo = _action.payload.pageNo;
      state.pageSize = _action.payload.pageSize;
      state.totalCount = _action.payload.totalCount;
    },
    resetSent_MessagesToInit: (state) => {
      state = initialState;
    },
    setSent_MessagesMessage: (
      state,
      _action: PayloadAction<{ text: string; type: string }>
    ) => {
      state.message = _action.payload;
    },
  },
});

export const {
  setSent_MessagesList,
  resetSent_MessagesToInit,
  setSent_MessagesMessage,
} = sent_messagesSlice.actions;

export default sent_messagesSlice.reducer;
